import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useMemo } from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { calcPrecentage } from "./ElectionEventStats";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
import { useTranslation } from "react-i18next";
var useTestingStats = function (props) {
    var enrolledVotersCount = props.enrolledVotersCount, votingStats = props.votingStats;
    var t = useTranslation().t;
    var authContext = useContext(AuthContext);
    var showVoterVotedTestElection = authContext.isAuthorized(true, authContext.tenantId, IPermissions.MONITOR_VOTERS_VOTED_TEST_ELECTION);
    var testSection = useMemo(function () {
        return {
            show: showVoterVotedTestElection,
            title: t("monitoringDashboardScreen.testing.title"),
            stats: [
                {
                    show: showVoterVotedTestElection,
                    title: t("monitoringDashboardScreen.testing.testElectionVoterCount"),
                    items: [
                        {
                            icon: _jsx(CheckCircleOutlineIcon, {}),
                            count: votingStats.votedTestsElectionsCount,
                            percentage: calcPrecentage(votingStats.votedTestsElectionsCount, enrolledVotersCount),
                        },
                    ],
                },
            ],
        };
    }, [showVoterVotedTestElection, votingStats, enrolledVotersCount]);
    return { testSection: testSection };
};
export default useTestingStats;
